import "./styles.scss";

import { IoMdArrowDown } from "react-icons/io";
import { useSelector } from "react-redux";
import { Checkbox } from "@nextui-org/react";

import { ChevronFullIcon } from "../../../assets/icons/audio-icons";

const GenericTable = ({
  items,
  getItemContent,
  titles,
  onRowClick = () => {},
  isClickable = true,
  sortDescriptor,
  setSortDescriptor,
  displaySelectAll = false,
  selectAllAction = () => {},
  isSelectAllChecked = false,
}) => {
  const { selectedCalls = [] } = useSelector((state) => state.calls.calls);
  const selectedcallsIds = selectedCalls?.map((call) => call.id) || [];

  const onToggleSort = (column) => () => {
    const { key: sortKey } = column;
    const isAlreadySortedBy = sortKey === sortDescriptor.sortBy;

    if (!isAlreadySortedBy) {
      setSortDescriptor({
        sortBy: sortKey,
        direction: "desc",
      });
    }

    if (isAlreadySortedBy) {
      setSortDescriptor({
        sortBy: sortKey,
        direction: sortDescriptor.direction === "desc" ? "asc" : "desc",
      });
    }
  };

  const totalFlexWidth = titles
    .map((item) => item.size)
    .reduce((accumulator, currentSum) => {
      return accumulator + currentSum;
    }, 0);

  const getPercentWidth = (size) => (size * 100) / totalFlexWidth;

  return (
    <div className="generic-table__wrapper mt-5 bg-white rounded-md">
      {/* Titles */}
      <div className="flex items-center px-[16px] py-[12px] border-b-1 border-b-[#E5E5E5] border-b-solid">
        {titles.map((title, titleIndex) => {
          const { sortable: isSortable, key, alignEnd: isEndAligned = false } = title;
          const isSortedBy = isSortable && key === sortDescriptor.sortBy;
          const isSortedByAsc = isSortedBy && sortDescriptor.direction === "asc";
          const isFirstItem = titleIndex === 0;
          const displaySelectAllChechbox = displaySelectAll && isFirstItem;

          return (
            <div
              style={{ flex: title.size, maxWidth: `${getPercentWidth(title.size)}%` }}
              key={`t-${titleIndex}`}
              className={`flex items-center gap-[8px] ${isSortable ? "cursor-pointer" : ""} ${
                isEndAligned ? "justify-end" : ""
              }`}
              {...(isSortable
                ? {
                    onClick: onToggleSort(title),
                  }
                : {})}
            >
              <div className="flex items-center">
                {!displaySelectAllChechbox && (
                  <span
                    className={`text-sm font-semibold text-[#404040]/[.6] whitespace-nowrap ${
                      isSortedBy ? "text-gray-700 font-semibold" : ""
                    }`}
                  >
                    {title.label}
                  </span>
                )}
                {displaySelectAllChechbox && (
                  <Checkbox
                    isSelected={isSelectAllChecked}
                    onValueChange={selectAllAction}
                  />
                )}
              </div>
              {isSortable && (
                <div
                  className={`mr-[12px] transition-all transform${
                    isSortedByAsc ? " rotate-180" : ""
                  }`}
                >
                  <IoMdArrowDown
                    size={18}
                    className="text-[#404040]/[.6]"
                  />
                  {/* <ChevronFullIcon size={12} /> */}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* Content */}
      <div>
        {items &&
          items?.map((item, itemIndex) => {
            const isLastItem = itemIndex === items.length - 1;
            const isSelected = selectedcallsIds.includes(item?.id);

            return (
              <div
                key={`i-${itemIndex}`}
                className={`${
                  isClickable ? "cursor-pointer" : ""
                } flex items-center px-[16px] py-[8px] ${
                  isSelected ? "bg-[#4318FF]/[0.6] generic-table__row-selected" : ""
                } ${isClickable ? "hover:bg-[#4318FF]/[0.6] generic-table__row-clickable" : ""}${
                  !isLastItem ? " border-b-1 border-b-[#E5E5E5] border-b-solid" : ""
                }`}
                onClick={onRowClick(item)}
                onKeyDown={onRowClick(item)}
              >
                {titles.map((column, columnIndex) => {
                  return (
                    <div
                      key={`c-${itemIndex}-${columnIndex}`}
                      style={{
                        flex: column.size,
                        maxWidth: `${getPercentWidth(column.size)}%`,
                      }}
                      className="flex items-center"
                    >
                      {getItemContent(item, column.key)}
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default GenericTable;
